

import React, { useState } from "react";
import { Button, Card, Col, Form, Row, Modal } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import ReCAPTCHA from "react-google-recaptcha";
// function Forgotpasswordpage() {
//   const [email, setEmail] = useState("");

//   const handleChange = (e) => {
//     setEmail(e.target.value);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Add code here to handle the submission (e.g., send a reset password email)
//   };

//   return (
//     <div className="container">
//     <div className="row justify-content-center">
//       <div className="col-md-6">
//         <div className="card mt-5">
//           <div className="card-body">
//             <h1 className="card-title">Forgot Your Password?</h1>
//             <p className="card-text">
//               Please enter your email address to reset your password.
//             </p>
//             <form onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <input
//                   type="email"
//                   className="form-control"
//                   placeholder="Email"
//                   value={email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <button type="submit" className="btn btn-primary">
//                 Reset Password
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   );
// }

// export default Forgotpasswordpage;







function Forgotpasswordpage() {
  const [email, setEmail] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
    const [isButtonDisabled, setButtonDisabled] = useState(true);

    const [sendmail, setsendmail] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleCaptchaChange = (value) => {
    // This function will be called when the user solves the reCAPTCHA
    setCaptchaValue(value);
    setButtonDisabled(false); // Enable the button when reCAPTCHA is solved
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (captchaValue === null) {
      // Check if the user hasn't solved the reCAPTCHA
      alert("Please complete the reCAPTCHA before submitting.");
    } else {
        // Add code here to handle the submission (e.g., send a reset password email)
        
        if (!isValidEmail(email)) {
            alert("Email is not valid.");
          } else {
           
            let data = {
              email: email,
              isnewuser: false,
            };
      
           
            setEmail("");
            setsendmail(true);
            
            // HandleOnChange(dispatch, {
            //   target: { name: "LoginId", value: "" },
            // });
            // console.log(forgotemail, "mail");
      
            // console.log(mail, "mail");
      
            await axios
              .post("http://localhost:2002/auth/password-reset/reset", data)
      
              .then((response) => {
                  console.log(JSON.stringify(response.data));
                  setsendmail(true);
                toast.success("Email sent if exist");
                // setEmail("");
              })
              .catch((error) => {
                  console.log(error);
                toast.error("Something went wrong");

              });
          }
    }
    };
    
    const containerStyle = {
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        padding: "40px",
        width: "100%",
        maxWidth: "500px",
        textAlign: "center",
        justifyContent: "center",
      };
      const buttonStyle = {
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        padding: "15px 20px",
        cursor: "pointer",
        fontSize: "16px",
        transition: "background-color 0.3s",
        width: "50%",
        textDecoration: "none",
        // boxShadow: "2px 5px 5px rgba(39, 158, 255,0.5)",
    };
    
    function isValidEmail(forgotemail) {
        // You can use a more robust email validation method here
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(forgotemail);
      }
    
    

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card mt-5">
            <div className="card-body">
              <h1 className="card-title">Forgot Your Password?</h1>
              <p className="card-text">
                Please enter your email address to reset your password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <ReCAPTCHA
                    sitekey="6LfCzKUoAAAAAGnh0NSdhPCMS0s_mQZGUfprFaXl"
                    onChange={handleCaptchaChange}
                  />
                </div>
                <button
                                  type="submit"
                                  
                  className="btn btn-primary"
                  disabled={isButtonDisabled} // Disable the button when reCAPTCHA is not solved
                >
                  Reset Password
                </button>
              </form>
            </div>
          </div>
        </div>
          </div>
          <Modal show={sendmail} backdrop="static" size="md" centered>
        {/* <Modal.Header className="bg-purple-dark">
          <Modal.Title>
            <b className="mdm-f text-white">Manage Role</b>
          </Modal.Title>
        </Modal.Header> */}
        {/* <Modal.Body> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={containerStyle}>
            {/* <svg
              width="150"
              height="50"
              viewBox="0 0 849 190"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_513_24204)">
                <rect width="849" height="190" fill="white" />
                <g clip-path="url(#clip1_513_24204)">
                  <rect
                    width="134.309"
                    height="68.4279"
                    transform="translate(14.1357 12)"
                    fill="white"
                  />
                  <path
                    d="M111.821 33.7393C101.88 33.7387 92.1749 35.8954 84.0024 39.9213C75.8299 43.9473 69.5791 49.6508 66.0848 56.2701L77.5174 59.3219C80.536 53.6121 86.2758 48.8365 93.7365 45.8273C101.197 42.8181 109.906 41.766 118.346 42.8543C126.785 43.9427 134.42 47.1025 139.92 51.7832C145.42 56.4639 148.437 62.3687 148.445 68.4688C148.445 75.377 144.586 82.0021 137.718 86.8869C130.85 91.7717 121.534 94.516 111.821 94.516H50.7823C42.1344 94.5198 33.7636 92.3471 27.1521 88.3826C20.5406 84.4181 16.1149 78.9175 14.6588 72.8548C13.2026 66.7922 14.8098 60.5586 19.196 55.2579C23.5821 49.9573 30.464 45.9315 38.6233 43.8934C38.1005 36.3945 41.4995 29.0234 48.165 23.2012C54.8306 17.379 64.2907 13.5178 74.7217 12.3622C85.1526 11.2066 95.8158 12.8382 104.656 16.9426C113.495 21.047 119.886 27.3335 122.595 34.5902C119.059 34.0241 115.446 33.7387 111.821 33.7393Z"
                    fill="url(#paint0_linear_513_24204)"
                  />
                </g>
                <g clip-path="url(#clip2_513_24204)">
                  <path
                    d="M137.117 62.528L137.028 62.4408L137.012 62.4218L81.285 7.85547L25.5589 62.4204L25.5425 62.4394L25.4505 62.5266C16.9292 70.9171 11.5167 81.8559 10.0735 93.6043C8.6302 105.353 11.239 117.236 17.4851 127.366C23.7312 137.496 33.2562 145.292 44.5459 149.512C55.8356 153.732 68.2421 154.136 79.7932 150.66C80.7653 150.369 81.8042 150.369 82.7763 150.66C94.3265 154.135 106.732 153.731 118.021 149.51C129.31 145.289 138.834 137.494 145.08 127.365C151.326 117.236 153.935 105.353 152.492 93.605C151.049 81.8573 145.638 70.9186 137.117 62.528ZM45.3744 98.5101C45.1031 98.7757 44.888 99.0913 44.7413 99.438C44.5945 99.7846 44.5189 100.157 44.519 100.532C44.6182 110.163 47.3978 119.584 52.5587 127.783C52.6759 127.969 52.7301 128.186 52.7135 128.404C52.6968 128.622 52.6103 128.829 52.4661 128.996C52.322 129.163 52.1276 129.281 51.9109 129.333C51.6942 129.385 51.4661 129.369 51.2595 129.286C47.3797 127.688 43.855 125.365 40.8827 122.448C34.7914 116.482 31.367 108.394 31.3615 99.9579C31.3559 91.5223 34.7698 83.4291 40.8533 77.4565L81.285 37.8712L121.715 77.4565C127.799 83.4284 131.214 91.5216 131.208 99.9579C131.203 108.394 127.778 116.482 121.687 122.448C118.714 125.365 115.19 127.688 111.311 129.286C111.104 129.369 110.875 129.385 110.659 129.333C110.442 129.281 110.248 129.162 110.103 128.996C109.959 128.829 109.872 128.622 109.856 128.403C109.839 128.186 109.893 127.968 110.011 127.782C115.173 119.584 117.954 110.163 118.054 100.532C118.054 100.157 117.978 99.7846 117.831 99.4372C117.683 99.0899 117.467 98.775 117.195 98.5094L98.0717 78.6481C97.8811 78.4924 97.6415 78.4071 97.3932 78.4071C97.1457 78.4071 96.9054 78.4924 96.7154 78.6481C96.5247 78.8031 96.3966 79.0194 96.352 79.2582C96.3074 79.4971 96.3499 79.7429 96.4722 79.9543C103.899 93.1146 97.5127 112.018 86.8619 122.448L86.8057 122.503C85.3357 123.927 83.3512 124.725 81.2836 124.724C79.2156 124.724 77.2316 123.924 75.7627 122.499L75.7109 122.448C65.0563 112.018 58.6729 93.1167 66.1013 79.9571C66.2234 79.7458 66.266 79.4999 66.2215 79.261C66.1771 79.0222 66.0485 78.8059 65.8582 78.6509C65.6679 78.4952 65.4279 78.4099 65.18 78.4099C64.9321 78.4099 64.6921 78.4952 64.5018 78.6509L45.3744 98.5101Z"
                    fill="url(#paint1_linear_513_24204)"
                  />
                </g>
                <rect
                  x="-12.7471"
                  y="72.3594"
                  width="188.033"
                  height="8.05001"
                  fill="white"
                />
                <path
                  d="M247.8 140.2L246.6 126H245.8C243.533 131.333 240.267 135.333 236 138C231.867 140.667 225.8 142 217.8 142C204.867 142 195.4 138.267 189.4 130.8C183.4 123.2 180.267 111.8 180 96.6C179.867 83 181.267 72.2 184.2 64.2C187.133 56.2 191.733 50.4667 198 47C204.267 43.5333 212.267 41.8 222 41.8C227.067 41.8 231.667 42.2667 235.8 43.2C239.933 44 243.267 45.1333 245.8 46.6L246.2 46.4V5.59999H278.2V140.2H247.8ZM228.2 114.8C233.533 114.8 237.867 113.133 241.2 109.8C244.533 106.467 246.2 100.933 246.2 93.2V72.2C241.267 70.2 235.467 69.2 228.8 69.2C222.533 69.2 218 70.7333 215.2 73.8C212.533 76.7333 211.2 82.7333 211.2 91.8C211.2 99.5333 212.267 105.333 214.4 109.2C216.667 112.933 221.267 114.8 228.2 114.8ZM388.034 137C384.301 138.333 379.101 139.533 372.434 140.6C365.901 141.533 358.101 142 349.034 142C337.568 142 327.768 140.533 319.634 137.6C311.634 134.533 305.568 129.4 301.434 122.2C297.301 114.867 295.234 104.733 295.234 91.8C295.234 74.2 299.234 61.4667 307.234 53.6C315.368 45.7333 327.901 41.8 344.834 41.8C356.968 41.8 366.501 43.5333 373.434 47C380.501 50.4667 385.501 55.4 388.434 61.8C391.501 68.0667 393.034 75.5333 393.034 84.2C393.034 86.7333 392.901 89.4667 392.634 92.4C392.501 95.3333 392.168 98.2 391.634 101L390.834 101.8H325.034C325.968 107.667 328.701 111.533 333.234 113.4C337.901 115.267 345.434 116.2 355.834 116.2C362.768 116.2 368.501 116.067 373.034 115.8C377.701 115.4 382.434 114.867 387.234 114.2L388.034 114.8V137ZM365.234 80.8C365.234 77.6 364.701 74.8667 363.634 72.6C362.701 70.2 360.768 68.4 357.834 67.2C354.901 65.8667 350.568 65.2 344.834 65.2C336.434 65.2 330.901 66.6667 328.234 69.6C325.701 72.4 324.434 76.1333 324.434 80.8H365.234ZM501.847 43.4L470.047 140.2H430.047L400.047 43.2V42.8H436.047C438.847 53.2 441.447 64.4667 443.847 76.6C446.38 88.7333 448.647 100.4 450.647 111.6H451.447C453.447 100.4 455.647 88.7333 458.047 76.6C460.58 64.4667 463.247 53.2 466.047 42.8H501.847V43.4ZM508.906 92.2C508.906 74.3333 512.706 61.4667 520.306 53.6C527.906 45.7333 540.773 41.8 558.906 41.8C571.04 41.8 580.773 43.5333 588.106 47C595.44 50.4667 600.706 55.9333 603.906 63.4C607.24 70.7333 608.906 80.3333 608.906 92.2C608.906 103.933 607.24 113.467 603.906 120.8C600.706 128.133 595.44 133.533 588.106 137C580.773 140.333 571.04 142 558.906 142C540.773 142 527.906 138.133 520.306 130.4C512.706 122.533 508.906 109.8 508.906 92.2ZM558.906 114.6C566.64 114.6 571.84 112.933 574.506 109.6C577.306 106.133 578.706 100.133 578.706 91.6C578.706 83.4667 577.306 77.6667 574.506 74.2C571.84 70.6 566.64 68.8 558.906 68.8C551.44 68.8 546.24 70.6 543.306 74.2C540.506 77.6667 539.106 83.4667 539.106 91.6C539.106 100.133 540.506 106.133 543.306 109.6C546.24 112.933 551.44 114.6 558.906 114.6ZM667.067 68.8H623.667V43H709.067V66L665.867 113.6V114H712.267V139.8H620.467V118.8L667.067 69.2V68.8ZM739.802 177L755.202 140.4L716.602 43.2V42.8H752.402C756.135 53.3333 759.602 63.9333 762.802 74.6C766.135 85.2667 768.802 96.2 770.802 107.4H771.202C773.202 96.3333 775.735 85.4667 778.802 74.8C782.002 64.1333 785.602 53.4667 789.602 42.8H824.002V43.4L772.602 177.4H739.802V177Z"
                  fill="black"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_513_24204"
                  x1="14.1357"
                  y1="66.1511"
                  x2="148.445"
                  y2="65.3104"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#412CFB" />
                  <stop offset="1" stop-color="#E306F6" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_513_24204"
                  x1="9.68554"
                  y1="106.347"
                  x2="152.88"
                  y2="106.347"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFA234" />
                  <stop offset="1" stop-color="#FF2674" />
                </linearGradient>
                <clipPath id="clip0_513_24204">
                  <rect width="849" height="190" fill="white" />
                </clipPath>
                <clipPath id="clip1_513_24204">
                  <rect
                    width="134.309"
                    height="68.4279"
                    fill="white"
                    transform="translate(14.1357 12)"
                  />
                </clipPath>
                <clipPath id="clip2_513_24204">
                  <rect
                    x="-21"
                    y="80.4258"
                    width="204.563"
                    height="72.573"
                    rx="13"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg> */}
            <Row className="d-flex align-items-center justify-content-center">
              <img
                style={{ width: "100px" }}
                src="https://cdn.pixabay.com/photo/2016/06/13/17/30/mail-1454731_1280.png"
              ></img>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {" "}
                  Password Reset Email Sent
                </p>
                <p>
                  A password reset email has been sent to your registered email
                  address. Please check your inbox and follow the instructions
                  in the email to reset your password.
                </p>
                <Col className="pt-1">
                  <button
                    style={buttonStyle}
                    onClick={() => {
                      setsendmail(false);
                    }}
                  >
                    OK
                  </button>
                </Col>
              </Col>
            </Row>

            {/* <Row className="mt-4">
              <Col>
                <h6>
                  Automatic redirect in sec to{" "}
                  <a href="https://sonar.yozytech.com">sonar.yozytech.com</a>
                </h6>
              </Col>
            </Row> */}
          </div>
        </div>
        {/* </Modal.Body> */}

        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div style={containerStyle}>
            <svg
              width="150"
              height="50"
              viewBox="0 0 849 190"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_513_24204)">
                <rect width="849" height="190" fill="white" />
                <g clip-path="url(#clip1_513_24204)">
                  <rect
                    width="134.309"
                    height="68.4279"
                    transform="translate(14.1357 12)"
                    fill="white"
                  />
                  <path
                    d="M111.821 33.7393C101.88 33.7387 92.1749 35.8954 84.0024 39.9213C75.8299 43.9473 69.5791 49.6508 66.0848 56.2701L77.5174 59.3219C80.536 53.6121 86.2758 48.8365 93.7365 45.8273C101.197 42.8181 109.906 41.766 118.346 42.8543C126.785 43.9427 134.42 47.1025 139.92 51.7832C145.42 56.4639 148.437 62.3687 148.445 68.4688C148.445 75.377 144.586 82.0021 137.718 86.8869C130.85 91.7717 121.534 94.516 111.821 94.516H50.7823C42.1344 94.5198 33.7636 92.3471 27.1521 88.3826C20.5406 84.4181 16.1149 78.9175 14.6588 72.8548C13.2026 66.7922 14.8098 60.5586 19.196 55.2579C23.5821 49.9573 30.464 45.9315 38.6233 43.8934C38.1005 36.3945 41.4995 29.0234 48.165 23.2012C54.8306 17.379 64.2907 13.5178 74.7217 12.3622C85.1526 11.2066 95.8158 12.8382 104.656 16.9426C113.495 21.047 119.886 27.3335 122.595 34.5902C119.059 34.0241 115.446 33.7387 111.821 33.7393Z"
                    fill="url(#paint0_linear_513_24204)"
                  />
                </g>
                <g clip-path="url(#clip2_513_24204)">
                  <path
                    d="M137.117 62.528L137.028 62.4408L137.012 62.4218L81.285 7.85547L25.5589 62.4204L25.5425 62.4394L25.4505 62.5266C16.9292 70.9171 11.5167 81.8559 10.0735 93.6043C8.6302 105.353 11.239 117.236 17.4851 127.366C23.7312 137.496 33.2562 145.292 44.5459 149.512C55.8356 153.732 68.2421 154.136 79.7932 150.66C80.7653 150.369 81.8042 150.369 82.7763 150.66C94.3265 154.135 106.732 153.731 118.021 149.51C129.31 145.289 138.834 137.494 145.08 127.365C151.326 117.236 153.935 105.353 152.492 93.605C151.049 81.8573 145.638 70.9186 137.117 62.528ZM45.3744 98.5101C45.1031 98.7757 44.888 99.0913 44.7413 99.438C44.5945 99.7846 44.5189 100.157 44.519 100.532C44.6182 110.163 47.3978 119.584 52.5587 127.783C52.6759 127.969 52.7301 128.186 52.7135 128.404C52.6968 128.622 52.6103 128.829 52.4661 128.996C52.322 129.163 52.1276 129.281 51.9109 129.333C51.6942 129.385 51.4661 129.369 51.2595 129.286C47.3797 127.688 43.855 125.365 40.8827 122.448C34.7914 116.482 31.367 108.394 31.3615 99.9579C31.3559 91.5223 34.7698 83.4291 40.8533 77.4565L81.285 37.8712L121.715 77.4565C127.799 83.4284 131.214 91.5216 131.208 99.9579C131.203 108.394 127.778 116.482 121.687 122.448C118.714 125.365 115.19 127.688 111.311 129.286C111.104 129.369 110.875 129.385 110.659 129.333C110.442 129.281 110.248 129.162 110.103 128.996C109.959 128.829 109.872 128.622 109.856 128.403C109.839 128.186 109.893 127.968 110.011 127.782C115.173 119.584 117.954 110.163 118.054 100.532C118.054 100.157 117.978 99.7846 117.831 99.4372C117.683 99.0899 117.467 98.775 117.195 98.5094L98.0717 78.6481C97.8811 78.4924 97.6415 78.4071 97.3932 78.4071C97.1457 78.4071 96.9054 78.4924 96.7154 78.6481C96.5247 78.8031 96.3966 79.0194 96.352 79.2582C96.3074 79.4971 96.3499 79.7429 96.4722 79.9543C103.899 93.1146 97.5127 112.018 86.8619 122.448L86.8057 122.503C85.3357 123.927 83.3512 124.725 81.2836 124.724C79.2156 124.724 77.2316 123.924 75.7627 122.499L75.7109 122.448C65.0563 112.018 58.6729 93.1167 66.1013 79.9571C66.2234 79.7458 66.266 79.4999 66.2215 79.261C66.1771 79.0222 66.0485 78.8059 65.8582 78.6509C65.6679 78.4952 65.4279 78.4099 65.18 78.4099C64.9321 78.4099 64.6921 78.4952 64.5018 78.6509L45.3744 98.5101Z"
                    fill="url(#paint1_linear_513_24204)"
                  />
                </g>
                <rect
                  x="-12.7471"
                  y="72.3594"
                  width="188.033"
                  height="8.05001"
                  fill="white"
                />
                <path
                  d="M247.8 140.2L246.6 126H245.8C243.533 131.333 240.267 135.333 236 138C231.867 140.667 225.8 142 217.8 142C204.867 142 195.4 138.267 189.4 130.8C183.4 123.2 180.267 111.8 180 96.6C179.867 83 181.267 72.2 184.2 64.2C187.133 56.2 191.733 50.4667 198 47C204.267 43.5333 212.267 41.8 222 41.8C227.067 41.8 231.667 42.2667 235.8 43.2C239.933 44 243.267 45.1333 245.8 46.6L246.2 46.4V5.59999H278.2V140.2H247.8ZM228.2 114.8C233.533 114.8 237.867 113.133 241.2 109.8C244.533 106.467 246.2 100.933 246.2 93.2V72.2C241.267 70.2 235.467 69.2 228.8 69.2C222.533 69.2 218 70.7333 215.2 73.8C212.533 76.7333 211.2 82.7333 211.2 91.8C211.2 99.5333 212.267 105.333 214.4 109.2C216.667 112.933 221.267 114.8 228.2 114.8ZM388.034 137C384.301 138.333 379.101 139.533 372.434 140.6C365.901 141.533 358.101 142 349.034 142C337.568 142 327.768 140.533 319.634 137.6C311.634 134.533 305.568 129.4 301.434 122.2C297.301 114.867 295.234 104.733 295.234 91.8C295.234 74.2 299.234 61.4667 307.234 53.6C315.368 45.7333 327.901 41.8 344.834 41.8C356.968 41.8 366.501 43.5333 373.434 47C380.501 50.4667 385.501 55.4 388.434 61.8C391.501 68.0667 393.034 75.5333 393.034 84.2C393.034 86.7333 392.901 89.4667 392.634 92.4C392.501 95.3333 392.168 98.2 391.634 101L390.834 101.8H325.034C325.968 107.667 328.701 111.533 333.234 113.4C337.901 115.267 345.434 116.2 355.834 116.2C362.768 116.2 368.501 116.067 373.034 115.8C377.701 115.4 382.434 114.867 387.234 114.2L388.034 114.8V137ZM365.234 80.8C365.234 77.6 364.701 74.8667 363.634 72.6C362.701 70.2 360.768 68.4 357.834 67.2C354.901 65.8667 350.568 65.2 344.834 65.2C336.434 65.2 330.901 66.6667 328.234 69.6C325.701 72.4 324.434 76.1333 324.434 80.8H365.234ZM501.847 43.4L470.047 140.2H430.047L400.047 43.2V42.8H436.047C438.847 53.2 441.447 64.4667 443.847 76.6C446.38 88.7333 448.647 100.4 450.647 111.6H451.447C453.447 100.4 455.647 88.7333 458.047 76.6C460.58 64.4667 463.247 53.2 466.047 42.8H501.847V43.4ZM508.906 92.2C508.906 74.3333 512.706 61.4667 520.306 53.6C527.906 45.7333 540.773 41.8 558.906 41.8C571.04 41.8 580.773 43.5333 588.106 47C595.44 50.4667 600.706 55.9333 603.906 63.4C607.24 70.7333 608.906 80.3333 608.906 92.2C608.906 103.933 607.24 113.467 603.906 120.8C600.706 128.133 595.44 133.533 588.106 137C580.773 140.333 571.04 142 558.906 142C540.773 142 527.906 138.133 520.306 130.4C512.706 122.533 508.906 109.8 508.906 92.2ZM558.906 114.6C566.64 114.6 571.84 112.933 574.506 109.6C577.306 106.133 578.706 100.133 578.706 91.6C578.706 83.4667 577.306 77.6667 574.506 74.2C571.84 70.6 566.64 68.8 558.906 68.8C551.44 68.8 546.24 70.6 543.306 74.2C540.506 77.6667 539.106 83.4667 539.106 91.6C539.106 100.133 540.506 106.133 543.306 109.6C546.24 112.933 551.44 114.6 558.906 114.6ZM667.067 68.8H623.667V43H709.067V66L665.867 113.6V114H712.267V139.8H620.467V118.8L667.067 69.2V68.8ZM739.802 177L755.202 140.4L716.602 43.2V42.8H752.402C756.135 53.3333 759.602 63.9333 762.802 74.6C766.135 85.2667 768.802 96.2 770.802 107.4H771.202C773.202 96.3333 775.735 85.4667 778.802 74.8C782.002 64.1333 785.602 53.4667 789.602 42.8H824.002V43.4L772.602 177.4H739.802V177Z"
                  fill="black"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_513_24204"
                  x1="14.1357"
                  y1="66.1511"
                  x2="148.445"
                  y2="65.3104"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#412CFB" />
                  <stop offset="1" stop-color="#E306F6" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_513_24204"
                  x1="9.68554"
                  y1="106.347"
                  x2="152.88"
                  y2="106.347"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFA234" />
                  <stop offset="1" stop-color="#FF2674" />
                </linearGradient>
                <clipPath id="clip0_513_24204">
                  <rect width="849" height="190" fill="white" />
                </clipPath>
                <clipPath id="clip1_513_24204">
                  <rect
                    width="134.309"
                    height="68.4279"
                    fill="white"
                    transform="translate(14.1357 12)"
                  />
                </clipPath>
                <clipPath id="clip2_513_24204">
                  <rect
                    x="-21"
                    y="80.4258"
                    width="204.563"
                    height="72.573"
                    rx="13"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
            <Row>
              <Col>
                <h3 className="font-weight-bold text-success">
                  <i className="mdi mdi-check-decagram"></i> Password
                  successfully reset.{" "}
                </h3>
              </Col>
            </Row>

            <Row></Row>
            <Row className="">
              <Col className="mt-4">
                <a style={buttonStyle} href="https://sonar.yozytech.com">
                  OK
                </a>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <h6>
                  Automatic redirect in sec to{" "}
                  <a href="https://sonar.yozytech.com">sonar.yozytech.com</a>
                </h6>
              </Col>
            </Row>
          </div>
        </div> */}
          </Modal>
          <ToastContainer/>
    </div>
  );
}

export default Forgotpasswordpage;


